import { Group, MeshBasicMaterial, Color, Mesh } from "three"
import { FontLoader, TextGeometry } from 'three/examples/jsm/Addons.js'

export { TextMark }

class TextMark extends Group {
    #fontLoader = new Promise(
        (res, rej) =>
            new FontLoader().load(
                new URL("/src/assets/fonts/Lato/LatoLatin_Regular.json", import.meta.url),
                res, undefined, rej)
    )

    #material = new MeshBasicMaterial({
        color: window.matchMedia('(prefers-color-scheme: dark)').matches ? new Color(0xfefefe) : new Color(0x000000),
        transparent: true,
        opacity: 1
    })

    async #text(text) {
        const textGeo = new TextGeometry(
            text,
            {
                size: .85,
                depth: 0,
                curveSegments: 12,
                bevelEnabled: false,
                font: await this.#fontLoader,
            }
        )

        return new Mesh(textGeo, this.#material)
    }

    constructor() {
        super()

        window.matchMedia('(prefers-color-scheme: dark)').addEventListener("change", ({ matches }) => {
            this.#material.color = matches ? new Color(0xfefefe) : new Color(0x000000)
            this.#material.needsUpdate = true
        })
    }

    async load() {
        const inno = await this.#text("I N N O")
        inno.position.x = 1.1
        inno.position.y = .6
        inno.position.z = .5

        const werk = await this.#text("W E R K")
        werk.position.x = .1
        werk.position.y = -.4
        werk.position.z = -.5

        this.add(inno, werk)
    }

    set opacity(value) {
        this.#material.opacity = value
    }

    get opacity() {
        return this.#material.opacity
    }
}